import { render, staticRenderFns } from "./GetActivationCode.vue?vue&type=template&id=b6fd0fb6&scoped=true"
import script from "./GetActivationCode.vue?vue&type=script&lang=js"
export * from "./GetActivationCode.vue?vue&type=script&lang=js"
import style0 from "./GetActivationCode.vue?vue&type=style&index=0&id=b6fd0fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fd0fb6",
  null
  
)

export default component.exports